import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";
import { FAQS, TERMS_AND_CONDITION } from "./helper";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

import OrderSummaryBackgroundImage from "public/images/jaguars/order-summary.png";
import MobileBannerImage from "public/images/jaguars/2025-ProwlPass-375x550-Sept2225.jpg";
import DesktopBannerImage from "public/images/jaguars/2025-ProwlPass-1920x450-Sept2225.jpg";

export const jaguars: TTeamConfig = {
  TEAM_SCHEMA: "jaguars",
  TEAM_FULL_NAME: "Jacksonville Jaguars",
  BROWSER_TITLE: "Prowl Pass",
  CLIENT_ID: "70b79cf58110.seasonshare.jaguars-jaguars.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#006778",
    COLORS_SECONDARY: "#D7A22A",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },
    FOOTER: {
      BACKGROUND_COLOR: "#006778",
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Purchase Now",
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },

    ADD_DARK_OVERLAY: true,
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://s3.us-east-2.amazonaws.com/ss-leagues/NFL/jacksonville-jaguars.png",
    LANDING_PAGE_STATIC_BANNER_URL: DesktopBannerImage.src,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: MobileBannerImage.src,
    GROUP_INVITE_PAGE_STATIC_BANNER_URL: DesktopBannerImage.src,
    ORDER_SUMMERY_BACKGROUND_URL: OrderSummaryBackgroundImage.src,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
